import { createAsyncThunk } from "@reduxjs/toolkit";
import { navigationSliceName } from ".";

const navigationJson = require("../../../../config/navigation.json");

const addId = (item) => {
  if (item.items) {
    item.items = item.items.map(addId);
  }
  if (!item.id) {
    item.id = Math.random().toString(36).slice(2);
  }
  return item;
};

export const navigationInitAction = createAsyncThunk(`${navigationSliceName}/navigationInit`, async () => {
  return navigationJson.items.map(addId);
});
